import { PDFDocument } from "pdf-lib";

export async function mergePdfDocuments(items, onProgress = () => {}) {
  const output = await PDFDocument.create();
  output.setCreator("smallpdf.app");
  output.setProducer("smallpdf.app Merge PDFs");
  const totalPages = items.reduce((sum, item) => sum + item.pageCount, 0);
  let completedPages = 0;

  for (const item of items) {
    const source = await PDFDocument.load(item.bytes.slice(), { updateMetadata: false });
    const pages = await output.copyPages(source, source.getPageIndices());
    for (const page of pages) {
      output.addPage(page);
      completedPages += 1;
      onProgress(completedPages, totalPages);
    }
  }

  return output.save({ useObjectStreams: true });
}
